module.exports = __webpack_public_path__ + "static/media/bl.9dc30a69.svg";